import { useCallback, useState, forwardRef, useImperativeHandle, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import {
  CardTitleWithColor,
  CardInfoWithBorderTitle,
  FormContainer,
  RadioWrapper,
  RadioLabel,
  SaveButton,
  WrapperContainerForm,
  WrapperButton,
  TextContainer,
} from './styled'
import BluesiteRadio from 'views/components/UI/BluesiteRadio'
import { INTERPRETATION_OPTIONS } from '../../constants'
import updateBetesaInterpretation from 'services/common/betesa/update-betesa-interpretation'
import { useNotification } from 'lib/context/notification.context'
import { useDispatch } from 'react-redux'
import { setInterpretation } from 'ducks/ui'
import { CardTitle } from '../../interpretation-detail/styled'
import { useSelector } from 'react-redux'
import { fetchGeneratePDF } from 'views/screens/Evaluated-User/pages/generate-reports-pdf/services/fetch-generate-report'
import { P } from 'views/components/UI/Text'
import { BoldParagraph } from '../user-info/styled'
import getBetesaReport from 'services/pdfReports/getBetesaReport'

export interface InterpretationFormHandles {
  submitInterpretation: (domination: string, predictedCorrect: boolean) => void
  selectedDomination: string
}

interface InterpretationFormProps {
  interpretation?: string
  userIdParam?: number
  testIdParam?: number
  loadingState?: (value: boolean) => void
  disabled?: boolean
  userTestId?: number
  oldPlatform?: boolean
  previousInterpretationInfo?: any
  onSubmit: () => void
  isReinterpretation?: boolean
  othersBetesaInPlatform?: any
}

const InterpretationForm = forwardRef<InterpretationFormHandles, InterpretationFormProps>(
  (
    {
      interpretation,
      userIdParam,
      testIdParam,
      loadingState,
      disabled,
      userTestId,
      oldPlatform,
      previousInterpretationInfo,
      onSubmit,
      isReinterpretation = false,
      othersBetesaInPlatform,
    },
    ref
  ) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { getSuccess, getError } = useNotification()
    const { search } = useLocation()
    const searchParams = useMemo(() => new URLSearchParams(search), [search])
    const id = searchParams.get('id')
    const [selectedDomination, setSelectedDomination] = useState(previousInterpretationInfo?.result?.domination || '')
    const { token } = useSelector((state: any) => state.user)

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setInterpretation(false))
      setSelectedDomination((event.target as HTMLInputElement).value)
    }

    const submitInterpretation = useCallback(
      async (domination: string, predictedCorrect: boolean) => {
        if (loadingState) {
          loadingState(true)
        }
        try {
          await updateBetesaInterpretation({
            domination: domination,
            userId: userIdParam ?? 0,
            testId: testIdParam ?? 0,
            betesaResultsId: Number(id),
            predictedCorrect: predictedCorrect,
          })
          await fetchGeneratePDF({
            userId: String(userIdParam),
            testId: String(testIdParam),
            userTestId: String(userTestId),
            token,
            type: 'betesa',
            isAdminReport: true,
            isReinterpretation: false,
          })

          getBetesaReport(userTestId || 0, true)

          dispatch(setInterpretation(true))
          const activeTab = searchParams.get('activeTab')
          getSuccess('Prueba interpretada correctamente.')
          if (isReinterpretation) {
            navigate(-1)
          } else {
            navigate(`/interpretation?activeTab=${activeTab}`)
          }
        } catch (error) {
          if (loadingState) {
            loadingState(false)
          }
          getError('Hubo un problema para interpretar la prueba, comuníquese con el administrador.')
        } finally {
          if (loadingState) {
            loadingState(false)
          }
        }
      },
      [
        userIdParam,
        testIdParam,
        id,
        userTestId,
        token,
        loadingState,
        dispatch,
        searchParams,
        getSuccess,
        isReinterpretation,
        navigate,
        getError,
      ]
    )

    useImperativeHandle(ref, () => ({
      submitInterpretation,
      selectedDomination,
    }))

    return (
      <CardInfoWithBorderTitle>
        <CardTitleWithColor>
          <CardTitle>Dominancia</CardTitle>
        </CardTitleWithColor>
        <WrapperContainerForm>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {othersBetesaInPlatform?.id && (
              <p style={{ color: '#d9006c', fontWeight: 'bold', fontSize: '18px', margin: 0, marginBottom: '8px' }}>
                Tiene Betesas anteriores
              </p>
            )}
            <FormContainer>
              {INTERPRETATION_OPTIONS.map((option, index) => (
                <RadioWrapper key={index}>
                  <BluesiteRadio
                    key={`${option.value}-${index}`}
                    checked={
                      selectedDomination === option.value || (interpretation === option.value && !selectedDomination)
                    }
                    onChange={handleChange}
                    value={option.value}
                    name="radio-buttons"
                    disabled={disabled}
                  />
                  <RadioLabel>{option.value}</RadioLabel>
                </RadioWrapper>
              ))}
            </FormContainer>
          </div>
          <WrapperButton>
            {!disabled && (
              <SaveButton disabled={!selectedDomination || disabled} onClick={onSubmit} allowed={!!selectedDomination}>
                Enviar
              </SaveButton>
            )}
          </WrapperButton>
        </WrapperContainerForm>
        {oldPlatform && (
          <TextContainer>
            <P>
              <BoldParagraph style={{ fontSize: '16px', color: '#c6016b' }}>EN PLATAFORMA ANTERIOR</BoldParagraph>
            </P>
          </TextContainer>
        )}
      </CardInfoWithBorderTitle>
    )
  }
)

export default InterpretationForm
